import type { TolgeeInstance } from "@tolgee/core";

type Catalog = Record<string, string>;

/** Admin copy stays deferred until an admin route is opened, including later language switches. */
export function createCatalogDelivery(
  app: Record<string, () => Promise<Catalog>>,
  admin: Record<string, () => Promise<Catalog>>,
) {
  let includeAdmin = false;
  const load = async (language: string): Promise<Catalog> => {
    const core = await app[language]();
    return includeAdmin ? { ...core, ...await admin[language]() } : core;
  };
  return {
    loaders: Object.fromEntries(Object.keys(app).map(language => [language, () => load(language)])),
    async loadAdmin(tolgee: Pick<TolgeeInstance, "addStaticData">, language: string) {
      if (!Object.prototype.hasOwnProperty.call(app, language)) throw new Error("Unknown bundled language");
      includeAdmin = true;
      const catalog = await load(language);
      // addStaticData replaces a record, so supply the complete artifact, not only its supplement.
      tolgee.addStaticData({ [language]: catalog });
    },
  };
}
